<dsd-link-action type="external" [customSrOnly]="'horsEcran.lienOuvreNouvelOnglet' | translate">
  <a [href]="urlPlanifierAppel" (click)="onClickPlanifierAppel()">{{
    'lien.planifierAppel' | translate
  }}</a>
</dsd-link-action>
